export const TEST_IDS = {
	USER_VERIFY: {
		LOADER: 'user-verify-loader',
	},
	MERCHANT_ANNOUNCEMENT_BAR: {
		CONTAINER: 'announcement-container',
		CLOSE_ICON: 'announcement-close-icon',
	},
	LOGIN: {
		PG_BANNER: 'pg-banner',
		SUCCESS_SCREEN: {
			SUCCESS_ICON: 'success-screen-success-icon',
			FAILED_ICON: 'success-screen-failed-icon',
			CROSS_ICON: 'success-screen-cross-icon',
			TITLE: 'success-screen-title',
			SUB_TITLE: 'success-screen-sub-title',
			CTA: 'success-screen-cta',
		},
		HELP_VIDEO: {
			MODAL: 'help-video-modal',
			MODAL_BODY: 'help-video-modal-body',
			MODAL_TITLE: 'help-video-modal-title',
		},
		INPUT_ERROR: {
			INFO_ICON: 'info-icon',
		},
		RESEND_OTP: {
			RESEND_TEXT: 'resend-text',
			RESEND_CTA: 'resend-cta',
		},
		GROUP_SELECTION_DRAWER: {
			USER_GROUP_ITEM: 'user-group-item',
		},
		LOGIN_LAYOUT: {
			PLAYSTORE_LOGO: 'login-footer-playstore-logo',
			APPSTORE_LOGO: 'login-footer-appstore-logo',
		},
		FORGOT_PASSWORD: {
			TITLE: 'forgot-password-title',
			SEND_LINK_CTA: 'forgot-password-send-link-cta',
			CANCEL_CTA: 'forgot-password-cancel-cta',
			EMAIL_INPUT: 'forgot-password-email-input',
			CROSS_ICON: 'forgot-password-cross-icon',
		},
	},
	DASHBOARD: {
		CHARTS: 'charts',
		NO_DATA: 'no-data',
	},
	TRANSACTIONS: {
		LIVE_BUTTON: 'live-icon',
		FILTERS_BUTTON: 'filters-button',
		REFRESH_BUTTON: 'refresh-button',
		TRANSACTIONS_LINK: 'transactions-link',
		LIVE_TRANSACTIONS_TABLE: 'live-transactions-details-table',
		FILTERS_TABLE: 'filter-table',
		STORE_NAME: 'store-name',
		GLOBAL_DETAILS_TABLE: 'global-table',
	},

	REFUNDS: {
		FILTERS_BUTTON: 'filters-button',
		SEARCH_BY_PHONE_NUMBER: 'Search-box-for-phone-number',
		STATUS_FILTER: 'status-filter-button',
	},

	REFUNDS_FILTERS_BUTTON: 'refunds-filters',
	SPLASH_CONTAINER: 'splash-container',

	CLEAR_ALL_FILTER_CHIPS: 'clear-all-filter-chips',
	FILTER_CHIPS_WRAPPER: 'wrapper-filter-chips',
	FILTER_CHIPS_GROUP: 'group-filter-chips',
	TABLE_ROWS: 'table-row',
	PAGE_HEADING: 'page-heading',
	PAGINATION_ID: 'pagination-block',
	DATE_RANGE: 'date-range',
	DATE_RANGE_DATE_TYPE_SELECTOR: 'date-range-date-type-selector',
	DATE_RANGE_DISPLAYED_DATE: 'date-range-displayed-date',
	DATE_PICKER_FOOTER_APPLY_BUTTON: 'date-picker-footer-apply',
	DATE_PICKER_FOOTER_CANCEL: 'date-picker-footer-cancel',
	DASHBOARD_HEADER_TEXT: 'dashboard-header-text',
	COACH_MARK_TOUR_MODAL_SKIP_BUTTON: 'tour-modal-skip-button',
	COACH_MARK_TOUR_MODAL_TAKE_A_TOUR_BUTTON: 'tour-modal-take-a-tour-button',
	FOOTER: {
		CONTAINER: 'footer-container',
		CONTACT_US: 'contact-us',
		TNC_TEXT: 'tnc-text',
		PRIVACY_POLICY_TEXT: 'privacy-policy-text',
	},
	SIDENAVBAR: {
		CONTAINER: 'side-navbar',
		MOBILE_BACKDROP_OVERLAY: 'mobile-backdrop-overlay',
		FAQ_LINK: 'faq-link',
	},
	TOP_NAVBAR: {
		CONTAINER: 'top-navbar',
		MOBILE_NAVBAR_BTN: 'mobile-navbar-btn',
	},
	NOTIFICATION_ICON: 'notification-icon',
	COACH_MARK_TOUR_MODAL_BANNER_IMAGE:
		'coachMark-TourModal-module-bannerContainer-image',
	COACH_MARK_TOUR_MODAL_BANNER_CONTENT:
		'coachMark-TourModal-module-bannerContainer-content',
	CUSTOM_DATE_RANGE_PICKER: 'custom-date-range-picker',
	CLOSE_CHAT_BOT_BUTTON: 'close-chat-bot-button',
	COLLAPSE_CHAT_BOT_BUTTON: 'collapse-chat-bot-button',
	LOADER_CHAT_BOT_BUTTON: 'loader-chat-bot-button',
	EXPAND_CHAT_BOT_BUTTON: 'expand-chat-bot-button',
	CHAT_BOT_IFRAME: 'chat-bot-iframe',
	DEVELOPER_SETTINGS: {
		API_KEYS_TABLE: 'api-keys-table',
		API_TEST_KEYS_TABLE: 'api-test-keys-table',
	},
	FILTERS_MODAL: {
		CLEAR_ALL_FILTERS_MODAL: 'clear-all-filters-modal',
		CROSS_ICON_BUTTON: 'cross-icon-button',
		APPLY_BTN: 'apply-filters-btn',
	},
	OM_ONBOARDING: {
		ONBOARDING_HEADER: 'onboarding-header',
		KYC_START_BUTTON: 'kyc-start-btn',
		RESUBMIT_KYC_BUTTON: 'resubmit-kyc-btn',
		EMAIL_VERIFICATION: 'email-verification',
		VERIFY_EMAIL_BUTTON: 'verify-email-btn',
		EMAIL_ID_TEXT: 'email-id',
		KYC_SUBMITTED: 'kyc-submitted',
		ACTIVATE_PG_BUTTON: 'activate-pg-btn',
		FULLNAME_INPUT: 'fullname-input',
		DISPLAY_NAME_INPUT: 'display-name-input',
		SUPER_CATEGORY_SELECT: 'super-category-select',
		BUSINESS_DESCRIPTION_INPUT: 'business-desc-input',
		WEBSITE_URL_INPUT: 'website-url-input',
		INTERNAL_URL_INPUT: 'internal-url-input',
		ANDROID_APP_URL_INPUT: 'android-app-url-input',
		ANDROID_PACKAGE_NAME_INPUT: 'android-package-name-input',
		IOS_APP_URL_INPUT: 'ios-app-url-input',
		IOS_PACKAGE_NAME_INPUT: 'ios-package-name-input',
		WEB_CHECKBOX: 'web-checkbox',
		ANDROID_CHECKBOX: 'android-checkbox',
		IOS_CHECKBOX: 'ios-checkbox',
		WEBSITE_TNC_INPUT: 'website-tnc-input',
		ANDROID_TNC_INPUT: 'android-tnc-input',
		IOS_TNC_INPUT: 'ios-tnc-input',
		WEB_REFUND_URL_INPUT: 'website-refund-url-input',
		ANDROID_REFUND_URL_INPUT: 'android-refund-url-input',
		IOS_REFUND_URL_INPUT: 'ios-refund-url-input',
		WEB_SHIPPING_URL_INPUT: 'website-shipping-url-input',
		ANDROID_SHIPPING_URL_INPUT: 'android-shipping-url-input',
		IOS_SHIPPING_URL_INPUT: 'ios-shipping-url-input',
		WEB_PRIVACY_URL_INPUT: 'website-privacy-url-input',
		ANDROID_PRIVACY_URL_INPUT: 'android-privacy-url-input',
		IOS_PRIVACY_URL_INPUT: 'ios-privacy-url-input',
		IOS_NO_SHIPPING_CHECKBOX: 'ios-no-shipping-checkbox',
		ANDROID_NO_SHIPPING_CHECKBOX: 'android-no-shipping-checkbox',
		WEB_NO_SHIPPING_CHECKBOX: 'web-no-shipping-checkbox',
		TNC_CHECKBOX: 'tnc-checkbox',
		ACTIVATION_NEXT_BUTTON: 'activation-next-btn',
		ACTIVATION_PREVIOUS_BUTTON: 'activation-previous-btn',
		WEB_RETURN_URL_INPUT: 'website-return-url-input',
		ANDROID_RETURN_URL_INPUT: 'android-return-url-input',
		IOS_RETURN_URL_INPUT: 'ios-return-url-input',
		WEB_NO_RETURN_CHECKBOX: 'web-no-return-checkbox',
		ANDROID_NO_RETURN_CHECKBOX: 'android-no-return-checkbox',
		IOS_NO_RETURN_CHECKBOX: 'ios-no-return-checkbox',
		PRODUCT_INFO_EXPAND_ICON: 'activation-info-expand-icon',
		POLICY_FORM: 'policy-form',
	},
	REGISTER: {
		BUSINESS_LOGO: 'register-business-logo',
		ALREADY_ACCOUNT_TEXT: 'register-already-account-text',
		LOGIN_BUTTON: 'register-login-button',

		LEAD_FILTER_SECTION_HEADER: 'register-lead-filter-section-header',
		BUSINESS_FILTER_SECTION_HEADER: 'business-filter-section-header',
		PRIVACY_POLICY_TEXT_LOGIN_PAGE: 'privacy-policy-text-login-page',
		TNC_LOGIN_PAGE: 'tnc-login-page',
		CONTACT_US_LOGIN_PAGE: 'contact-us-login-page',
		REGISTER_SECTION_HEADER: 'register-register-section-header',
		B2B_PG_RADIO_BUTTON: 'register-b2b-pg-radio-button',
		MASS_RADIO_BUTTON: 'register-mass-radio-button',
		B2B_PAYMENT_GATEWAY: 'register-payment-gateway',
		B2B_PAYMENT_LINK: 'register-payment-link',
		EMAIL_TEXTBOX: 'register-email-textbox',
		EMAIL_TEXTBOX_LABEL: 'register-email-textbox-label',
		EMAIL_TEXTBOX_ERROR_TEXT: 'register-email-textbox-error-text',
		WEBSITE_URL_TEXTBOX_ERROR_TEXT: 'register-website-url-textbox-error-text',
		PHONE_NUMBER_TEXT_BOX: 'register-phone-number-text-box',
		PHONE_NUMBER_TEXTBOX_LABEL: 'register-phone-number-textbox-label',
		PHONE_NUMBER_TEXTBOX_ERROR_TEXT: 'register-phone-number-textbox-error-text',
		PHONE_NUMBER_TEXTBOX_PREFIX: 'register-phone-number-textbox-prefix',
		VERIFY_BUTTON: 'register-verify-button',
		OTP_TEXT_BOX: 'register-otp-text-box',
		OTP_TEXT_BOX_LABEL: 'register-otp-text-box-label',
		OTP_TEXT_BOX_ERROR_TEXT: 'register-otp-text-box-error-text',
		RESEND_BUTTON: 'register-resend-button',
		REGISTER_PROCEED_BUTTON: 'register-register-proceed-button',
		TERMS_AND_CONDITIONS_TEXT: 'register-terms-and-conditions-text',
		TERMS_AND_CONDITIONS_LINK: 'register-terms-and-conditions-link',
	},
	GENERATE_TNC: {
		BUSINESS_NAME_LABEL: 'business-name',
		BUSINESS_URL_LABEL: 'business-url',
		BUSINESS_ADDRESS_LABEL: 'business-address',
		REFUND_REQUEST_TIME_LABEL: 'refund-request-time',
		REFUND_PROCESSING_TIME_LABEL: 'refund-processing-time',
		SHIPPING_TIME_LABEL: 'shipping-time',
		RETURN_REQUEST_TIME_LABEL: 'return-request-time',
		DOWNLOAD_PDF_POLICY: 'download-pdf-policy',
		DOWNLOAD_TXT_POLICY: 'download-txt-policy',
		DISCLAIMER_CONSENT: 'disclaimer-consent',
		DISCLAIMER_PREVIEW: 'disclaimer-preview',
	},
	MERCHANT_CALLBACK: {
		ICON: 'merchant-callback-icon',
	},
	REPORT_STATUS_CARD: {
		DOWNLOAD_BTN: 'report-download-btn',
		GOTO_REPORTS_BTN: 'go-to-Reports-btn',
		GENERATE_REPORTS_BTN: 'generate-reports-btn',
	},
	MERCHANT_LIST: {
		OPEN_MODAL_BTN: 'show-modal-btn',
		CANCEL_MODAL_BTN: 'cancel-modal-btn',
		APPLY_MERCHANTS_BTN: 'apply-merchant-btn',
		MODAL: 'merchant-list-modal',
	},
	PAGE_HEADER: {
		GO_BACK: 'page-header-go-back',
	},
	SIDE_PROFILE: {
		BUSINESS_SELECT_BTN: 'side-profile-business-select-btn',
		GOTO_PROFILE: 'goto-side-profile',
		LOGOUT_BTN: 'side-profile-logout-btn',
		OPEN_BUSINESS_LIST_BTN: 'open-side-profile-business-list-btn',
	},
	COACH_MARK: {
		TAKE_TOUR: 'take-tour',
		NEXT_BTN: 'coachmark-next-btn',
		PREV_BTN: 'coachmark-prev-btn',
		SKIP_TOUR: 'skip-tour',
	},
	MANAGE_USERS: {
		MANAGE_USER_CONTAINER: 'manage-user-container',
		ADD_NEW_USER_MODAL: 'add-new-user-modal',
		ADD_NEW_USER_BUTTON: 'add-new-user-button',
		ADD_NEW_USER_PHONENUMBER_INPUT: 'add-user-modal-phoneNumber-input',
		ADD_NEW_USER_NAME_INPUT: 'add-user-modal-user-name-input',
		ADD_NEW_USER_SELECT_BOX: 'add-user-select-box',
		ADD_NEW_USER_EMPTY_CONTAINER: 'add-user-button-empty-container',
		ADD_NEW_USER_CANCEL_BUTTON: 'add-new-user-modal-cancel-button',
		ADD_NEW_USER_SUBMIT_BUTTON: 'add-new-user-modal-submit-button',
		EDIT_USER_ROLE_MODAL: 'edit-user-role-modal',
		EDIT_USER_ROLE_MODAL_DROPDOWN: 'edit-user-role-modal-dropdown',
		USER_TABLE_DELETE_ICON: 'delete-user-icon',
		USER_TABLE_ROLE_COLUMN: 'user-table-role-column',
		USER_TABLE_LINKED_STORE_COLUMN: 'user-table-linked-store-column',
		MANAGE_USER_ROLE_MODAL: 'manage-user-role-modal',
		MANAGE_USER_ROLE_MODAL_OPTION: 'manage-user-role-option',
		MANAGE_USER_STORE_ACCESS_MODAL: 'manage-store-access-modal',
		DELETE_USER_ROLE_MODAL: 'delete-user-role-modal',
		DELETE_USER_CANCEL_BUTTON: 'delete-user-cancel-button',
		DELETE_USER_SUBMIT_BUTTON: 'delete-user-submit-button',
		EDIT_USER_CANCEL_BUTTON: 'edit-user-cancel-button',
		EDIT_USER_SUBMIT_BUTTON: 'edit-user-submit-button',
		MANAGE_USER_STORE_SUBMIT_BUTTON: 'manage-user-store-access-submit-button',
		MANAGE_USER_STORE_ACCESS_SEARCH_INPUT: 'manage-user-store-search-input',
		MANAGE_USER_STORE_TOGGLE_BUTTON: 'manage-user-store-toggle-button',
		MANAGE_USER_STORE_OPTION: 'manage-user-store-option',
	},
	CHATBOT_CONTAINER: 'chatbot-container',
	PROFILE: {
		PROFILE_WITH_AVATAR: 'profile-with-avatar',
		RESET_PASSWORD_BUTTON: 'reset-button-password',
		USER_DETAILS: 'user-details',
		BUSINESS_DETAILS: 'business-details',
		BANK_ACCOUNT_DETAILS: 'bank-account-details',
		PAYMENT_OPTIONS: 'payment-options',
	},
	ONLINE_PAYLINKS: {
		LINK_EXPIRES_INPUT: 'link-expires-input',
	},
};
